<template>
  <div class="header">
    <a-menu mode="horizontal"
            @click="handleMenuClick"
            v-model="nowMenu">
      <a-menu-item key=""
                   style="width:100px">
        全部
      </a-menu-item>
      <a-menu-item key="0"
                   style="width:100px">
        已发布
      </a-menu-item>
      <a-menu-item key="1"
                   style="width:100px">
        未发布
      </a-menu-item>
      <a-menu-item key="2"
                   style="width:100px">
        已删除
      </a-menu-item>
    </a-menu>
    <div class="header-opreation">
      <a-select :size="size"
                style="width: 200px;border-bottom: none"
                @change="handleChange"
                allowClear
                :showArrow="false"
                placeholder="模块名称筛选">
        <a-select-option v-for="(item,index) in options"
                         :key="index"
                         :value="item.value">
          {{item.label}}
        </a-select-option>
      </a-select>
      <a-input ref="userNameInput"
               v-model="searchText"
               @pressEnter="toSearch"
               placeholder="输入标题(关键词)搜索"
               style="width:250px">
        <a-icon slot="prefix"
                type="search" />
      </a-input>
      <a-button type="primary"
                style="width:100px"
                @click="add">
        新增
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array //模块筛选值
  },
  data() {
    return {
      nowMenu: [''],
      current: '',
      size: 'default', //模块筛选框
      searchText: '' //搜索值
    }
  },
  methods: {
    //模块筛选Change事件
    handleChange(instance) {
      console.log(instance)
      this.$emit('moduleClick', instance)
    },
    //搜索事件
    toSearch(val) {
      this.$emit('titleClick', val.target._value)
    },
    //弹出编辑框
    add() {
      this.$emit('add')
    },
    //菜单点击
    handleMenuClick(instance) {
      console.log(instance.key)
      if (
        instance.key === '' ||
        instance.key === '0' ||
        instance.key === '1' ||
        instance.key === '2'
      ) {
        this.$emit('menuClick', instance)
        this.current = instance.key
      } else {
        this.nowMenu = [this.current]
      }
    }
  }
}
</script>